import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./index.module.css";

const SimilarProductSkeletonCard = () => {
  return (
    <div className={styles.similarProductItem}>
      <div
        className={`${styles.similarProductMedia} ${styles.similarProductSkeletonMedia}`}
      >
        <Skeleton height="100%" width="100%" />
      </div>

      <div className={`${styles.itemInfo} ${styles.similarProductSkeletonInfo}`}>
        <Skeleton height={14} width="72%" />
        <Skeleton height={16} width="38%" />
        <Skeleton height={10} width="52%" />
      </div>
    </div>
  );
};

export default SimilarProductSkeletonCard;
